module.exports = __webpack_public_path__ + "img/appAsset-brand--khipu.2a6a4bfb.svg";